import { render } from "./ResponseQuotesModule.vue?vue&type=template&id=2b24880b&lang=html"
import script from "./ResponseQuotesModule.vue?vue&type=script&lang=js"
export * from "./ResponseQuotesModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__